import { AppThunkAPI } from "@shared/models/redux";
import { createInFlightPromiseCache } from "@shared/utils/inFlightRegistry";

type CallGetDocumentDownloadUrl = (documentId: string) => AppThunkAPI<Promise<string>>;

const inFlightUrlFetches = createInFlightPromiseCache<string, string>();

export const callGetDocumentDownloadUrl: CallGetDocumentDownloadUrl =
  (documentId) => async (_dispatch, _state, extra) =>
    inFlightUrlFetches.run(documentId, async () => {
      const response = await extra<string>(`documents/v1/documents/${documentId}/download?save=true`);
      const data = response.data;

      // RequestService normalizes 204 No Content to `{ data: [] }`. Coerce any non-string
      // payload (null, [], object, etc.) into "" so callers can rely on a falsy check.
      return typeof data === "string" ? data : "";
    });
